import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-private-note',
  templateUrl: './contact-private-note.component.html',
  styleUrls: ['./contact-private-note.component.scss'],
})
export class ContactPrivateNoteComponent implements OnInit {
  type: string;
  note: string;
  privateNote: string;


  constructor() {
  }

  ngOnInit() {
  }
}
